/// <amd-module name="typeahead/features/MultiRegionParentUrlModifier"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [
    {
        lobs: ["HOTELS"],
    },
];

const MULTIREGION_PARENT = "multiregion_parent";

export class MultiRegionParentUrlModifier implements IRequestUrlParamModifier, IExperimentalFeature {

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
        ISuggestServiceQueryParams {
        return addFeatureFlag(MULTIREGION_PARENT, configuration, params, context);
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

}
